export default [
  {
    title: 'Dashboard',
    group: 'apps',
    icon: 'fa-tachometer-alt',
    name: 'Dashboard',
    roleId: 1,
  },
  {
    title: 'Hashtag đơn hàng',
    group: 'apps',
    icon: 'fa-tag',
    name: 'hashtag-don-hang',
    roleId: 32
  },
  {
    title: 'Báo cáo',
    group: 'bao-cao',
    icon: 'fa-chart-line',
    name: 'Report',
    roleId: 4,
    items: [
      {
        title: 'Công nợ',
        name: 'bao-cao-cong-no',
        component: 'bao-cao-cong-no',
        roleId: 8
      },
      {
        title: 'Doanh thu',
        name: 'bao-cao-doanh-thu',
        component: 'bao-cao-doanh-thu',
        roleId: 4
      },
      {
        title: 'Lợi nhuận đặt hàng',
        name: 'thong-ke-loi-nhuan-dat-hang',
        component: 'thong-ke-loi-nhuan-dat-hang',
        roleId: 1,
      },
      // { 
      //   title: 'Phí mua hàng',
      //   name: 'thong-ke-phi-mua-hang',
      //   component: 'thong-ke-phi-mua-hang',
      //   roleId: 2,
      // },
      // {
      //   title: 'Phí vận chuyển',
      //   name: 'thong-ke-phi-van-chuyen',
      //   component: 'thong-ke-phi-van-chuyen',
      //   roleId: 4
      // },
      {
        title: 'Chênh lệch tỷ giá',
        name: 'thong-ke-tien-te',
        component: 'thong-ke-tien-te',
        roleId: 8,
      },
      {
        title: 'Thống kê nạp tiền',
        name: 'bao-cao-nap-tien',
        component: 'bao-cao-nap-tien',
        roleId: 8
      },
      {
        title: 'Thống kê hoa hồng',
        name: 'thong-ke-hoa-hong-nhan-vien',
        component: 'thong-ke-hoa-hong-nhan-vien',
        roleId: 8
      },
      // {
      //   title: 'Doanh thu tổng',
      //   name: 'bao-cao-tong-hop',
      //   component: 'bao-cao-tong-hop',
      //   roleId: 8
      // },
    ]
  },
  {
    title: 'Đơn hàng',
    group: 'apps',
    icon: 'fa-shopping-cart',
    name: 'OrderList',
    roleId: 32,
    badge: false,
    children: [
      { name: 'orderdetail', title: 'Chi tiết đơn hàng', component: 'OrderDetail' }
    ]
  },
  {
    title: 'Ký gửi',
    group: 'apps',
    icon: 'fa-cart-plus',
    name: 'Deposit',
    roleId: 16,
    badge: false,
    children: [
      { name: 'DepositDetail', title: 'Chi tiết đơn hàng', component: 'DepositDetail' }
    ]
  },
  {
    title: 'Thanh toán hộ',
    group: 'thanh-toan-ho',
    icon: 'fa-credit-card',
    name: 'PayService',
    roleId: 64,
    items: [
      {
        title: 'Trực tiếp',
        component: 'PayServiceList',
        roleId: 1
      },
      {
        title: 'Ủy quyền',
        component: 'PayAuthorityList',
        roleId: 1
      }
    ]
  },
  {
    title: 'Kế toán',
    group: 'ke-toan',
    icon: 'fa-chart-line',
    name: 'Accountant',
    roleId: 128,
    items: [
      {
        title: 'Thanh toán',
        component: 'PayOrderList',
        roleId: 128
      },
      {
        title: 'Kiểm soát đơn hàng',
        component: 'AccountantOrder',
        roleId: 16
      },
      {
        title: 'Tài chính',
        name: 'bao-cao-tai-chinh',
        component: 'bao-cao-tai-chinh',
        roleId: 16,
      },
      // {
      //   title: 'Luồng thu chi (¥)',
      //   component: 'AccountantCumulationList',
      //   roleId: 1
      // },
      // {
      //   title: 'Luồng thu chi (₫)',
      //   component: 'AccountantCumulationVNDList',
      //   roleId: 1
      // },
      {
        title: 'Shop hoàn tiền KN',
        component: 'TuiKuanList',
        roleId: 16
      },
    ]
  },
  // {
  //   title: 'Lead Manager',
  //   group: 'lead-manager',
  //   icon: 'fa-graduation-cap',
  //   name: 'LeadManager',
  //   roleId: 65536,
  //   items: [
  //     {
  //       title: 'Liên hệ',
  //       component: 'ContactList',
  //       roleId: 32
  //     },
  //     {
  //       title: 'Chăm sóc',
  //       component: 'ContactCareList',
  //       roleId: 32
  //     },
  //     {
  //       title: 'Cơ hội',
  //       component: 'OpportunityKaban',
  //       roleId: 32,
  //     },
  //     {
  //       title: 'Khách hàng',
  //       component: 'ContactCustomerList',
  //       roleId: 32
  //     },
  //     {
  //       title: 'Báo cáo',
  //       component: 'ContactReport',
  //       roleId: 32
  //     },
  //   ]
  // },  
  // {
  //   title: 'Tài chính nội bộ',
  //   group: 'apps',
  //   icon: 'fa-university',
  //   name: 'InternalFinanceList',
  //   roleId: 32768,
  //   children: [
  //     { name: 'InternalFinanceDetail', title: 'Chi tiết thu chi', component: 'InternalFinanceDetail'  }
  //   ]
  // },
  {
    title: 'Khách hàng',
    group: 'apps',
    icon: 'fa-user',
    name: 'CustomerList',
    roleId: 8,
    children: [
      { name: 'CustomerDetail', title: 'Chi tiết khách hàng', component: 'CustomerDetail'  }
    ]
  },
  {
    title: 'Nạp tiền',
    group: 'apps',
    icon: 'fa-wallet',
    name: 'RechargeNew',
    roleId: 16384
  },
  {
    title: 'Rút tiền',
    group: 'apps',
    icon: 'fa-wallet',
    name: 'WithdrawHistory',
    roleId: 16384   
  },
  {
    title: 'Khiếu nại',
    group: 'khieu-nai',
    icon: 'fa-exclamation-circle',
    name: 'ComplainGroup',
    roleId: 4096,
    items: [
      {
        title: 'Đơn hàng',
        component: 'Complain',
        roleId: 1
      },
      {
        title: 'Thanh toán hộ',
        component: 'PayAuthorityComplain',
        roleId: 2
      }
    ]
  },
  {
    title: 'Mã vận đơn',
    group: 'apps',
    icon: 'fa-cubes',
    name: 'Transaction',
    roleId: 512
  },
  // {
  //   title: 'Thu chi kho TQ',
  //   group: 'apps',
  //   icon: 'fa-info-circle',
  //   name: 'StoreReportList',
  //   roleId: 8192
  // }, 
  {
    title: 'Nhập kho TQ',
    group: 'apps',
    icon: 'fa-warehouse',
    name: 'StoreManager',
    roleId: 1024
  },
  {
    title: 'Bao hàng',
    group: 'apps',
    icon: 'fa-box',
    name: 'BigPackage',
    roleId: 2048
  }, 
  {
    title: 'Nhập kho VN',
    group: 'apps',
    icon: 'fa-store',
    name: 'StoreManagerVN',
    roleId: 256
  }, 
  // {
  //   title: 'Kho VN',
  //   group: 'kho-vn',
  //   icon: 'fa-store',
  //   name: 'StoreVN',
  //   roleId: 256,
  //   items: [
  //     {
  //       title: 'Nhập kho',
  //       component: 'StoreManagerVN',
  //       roleId: 1
  //     },
  //     {
  //       title: 'Lưu kho',
  //       component: 'StoreVNKennel',
  //       roleId: 1
  //     },
  //     {
  //       title: 'Kiểm kho',
  //       component: 'StoreVNCheck',
  //       roleId: 1
  //     }
  //   ]
  // },
  {
    title: 'Xuất kho VN',
    group: 'apps',
    badge: true,
    icon: 'fa-dolly-flatbed',
    name: 'Deliverable',
    roleId: 512
  },
  {
    title: 'Cài đặt',
    group: 'cai-dat',
    icon: 'fa-cogs',
    name: 'Setting',
    roleId: 2,
    items: [
      {
        name: 'Configuration', 
        title: 'Cấu hình chung', 
        component: 'Configuration',
        roleId: 128
      },
      {
        name: 'ConfigPrice', 
        title: 'Bảng giá thanh toán hộ', 
        component: 'ConfigPrice',
        roleId: 64
      },
      {
        name: 'FlagList', 
        title: 'Hashtag', 
        component: 'FlagList', 
        children: [
          { name: 'FlagDetail', title: 'Chi tiết hashtag', component: 'FlagDetail' }
        ],
        roleId: 128
      },
      {
        title: 'Kho hàng TQ',
        name: 'ChinaStoreList',
        component: 'ChinaStoreList', 
        children: [
          { name: 'ChinaStoreDetail', title: 'Chi tiết kho TQ', component: 'ChinaStoreDetail' }
        ],
        roleId: 128
      },
      {
        title: 'Kho hàng VN',
        name: 'WarehouseList',
        component: 'WarehouseList', 
        children: [
          { name: 'WarehouseDetail', title: 'Chi tiết kho', component: 'WarehouseDetail' }
        ],
        roleId: 128
      },
      {
        title: 'Nhân viên',
        name: 'StaffList',
        roleId: 1,
        component: 'StaffList', 
        children: [
          { name: 'StaffDetail', title: 'Chi tiết nhân viên', component: 'StaffDetail' }
        ],
        roleId: 128
      },
      {
        name: 'FeeBuyList', 
        title: 'Phí mua hàng', 
        component: 'FeeBuyList', 
        children: [
          { name: 'FeeBuyDetail', title: 'Chi tiết phí mua hàng', component: 'FeeBuyDetail' }
        ],
        roleId: 128
      },
      {
        name: 'PricesList', 
        title: 'Bảng giá vận chuyển', 
        component: 'PricesList', 
        children: [
          { name: 'PricesDetail', title: 'Chi tiết bảng giá', component: 'PricesDetail' }
        ],
        roleId: 128
      },
      // {
      //   name: 'FeeWeightList', 
      //   title: 'Phí cân nặng', 
      //   component: 'FeeWeightList', 
      //   children: [
      //     { name: 'FeeWeightDetail', title: 'Chi tiết phí cân nặng', component: 'FeeWeightDetail' }
      //   ]
      // },
      // {
      //   name: 'FeeVolumeList', 
      //   title: 'Phí khối', 
      //   component: 'FeeVolumeList', 
      //   children: [
      //     { name: 'FeeVolumeDetail', title: 'Chi tiết phí khối', component: 'FeeVolumeDetail' }
      //   ]
      // },
      {
        name: 'FeeCheckList', 
        title: 'Phí kiểm đếm', 
        component: 'FeeCheckList', 
        children: [
          { name: 'FeeCheckDetail', title: 'Chi tiết phí kiểm đếm', component: 'FeeCheckDetail' }
        ],
        roleId: 128
      },
      {
        name: 'FeeGuaranteeList', 
        title: 'Phí bảo hiểm', 
        component: 'FeeGuaranteeList', 
        children: [
          { name: 'FeeGuaranteeDetail', title: 'Chi tiết phí bảo hiểm', component: 'FeeGuaranteeDetail' }
        ],
        roleId: 128
      },
      {
        name: 'FeeReinforceList', 
        title: 'Phí gia cố', 
        component: 'FeeReinforceList', 
        children: [
          { name: 'FeeReinforceDetail', title: 'Chi tiết phí gia cố', component: 'FeeReinforceDetail' }
        ],
        roleId: 128
      },
      { 
        name: 'CustomerLevel', 
        title: 'Khách hàng thân thiết', 
        component: 'CustomerLevel',
        children: [
          { name: 'CustomerLevelDetail', title: 'Chi tiết level', component: 'CustomerLevelDetail' }
        ],
        roleId: 128
      }
    ]
  },
  // {
  //   title: 'Nhập liệu',
  //   group: 'apps',
  //   icon: 'input',
  //   name: 'DataManager',
  // },  
];
